import React from "react";
import styles from "./TotalAnimalTable.module.css";

interface AnimalData {
  key: number;
  animal: string;
  count: number;
}

const dataSource: AnimalData[] = [
  {
    key: 1,
    animal: "Реализация молока",
    count: 1374963,
  },
  {
    key: 2,
    animal: "Реализация шерсти в физическом весе",
    count: 5653    ,
  },
  {
    key: 3,
    animal: "Реализация яиц",
    count: 498576    ,
  },
  {
    key: 4,
    animal: "Реализация мяса в убойном весе",
    count: 290732    ,
  },

];

export const SalesTotaltypesOfproducts: React.FC = () => {
  return (
    <div className={styles.container}>
      <div className={styles.container_inner}>
        <h2>Реализация</h2>
        <ul className={styles.table}>
          <li className={styles.header}>
            <span className={styles.cell}>Реализация основных видов с/х продукции  по линии животноводства
            </span>
            <span className={styles.cell}>тонн</span>
          </li>
          {dataSource.map((item) => (
            <li key={item.key} className={styles.row}>
              <span className={styles.cell}>{item.animal}</span>
              <span className={styles.cell}>{item.count.toLocaleString()}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};


